import { React, useEffect, useState, Fragment, useCallback } from "react";

import cogoToast from "cogo-toast";
import { SUCCESS_RESULT, TEMPLATES_URL, ENDPOINTS, LOCAL_PATHS } from "../../Constants";
import { getTemplateByName, genericPost } from "../../services/Api";
 

import { Spinner } from "reactstrap";
import { useHistory, Link } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Table, Button } from "reactstrap";
import * as SurveyCore from "survey-core"; 
import { Survey } from 'survey-react-ui'; 
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import 'survey-core/modern.min.css';
import "./styles.css";


const UpdateBeneficiaryDetails = (props) => {
 
  const { beneficiary_inst_id,child_inst_id,component_id,project_id } = (props.location && props.location.state) || {};

    // console.log("Data is here>><<:: " + JSON.stringify(props.location.data.id));
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [template, setTemplate] = useState(null);
    const [beneficiary_details, setBeneficiary_details] = useState(null);
    const [formData, setFormData] = useState(null);
 
    SurveyCore.StylesManager.applyTheme("modern");
  
    let surveyModel = new SurveyCore.Model(template);
    setTimeout(() => {
    beneficiary_details.score= 99.95;
    beneficiary_details.can_proceed=true;
    beneficiary_details.hh_women_headed=1;
    beneficiary_details.hh_child_headed= 1;
    beneficiary_details.chronic_illness= 1;
    beneficiary_details.unreliable_income= 1;
    beneficiary_details.lactating_mother= 1;
    beneficiary_details.less_food_reserve= 1;
    beneficiary_details.elderly_person= 1;
    beneficiary_details.employed= 1;
    beneficiary_details.supported= 1;
    beneficiary_details.assistance= 1;
    beneficiary_details.total_asset= 1;
    beneficiary_details.access_health= 1;
    beneficiary_details.access_water= 1;
    beneficiary_details.sanitation= 1;
    beneficiary_details.access_electricity= 1;
    beneficiary_details.access_meal= 1;
    beneficiary_details.working= 1;
    beneficiary_details.loans= 1;
    beneficiary_details.sell_assets= 1;

        surveyModel.data= beneficiary_details;
    }, 100);

    useEffect(() => {
 
         getBNFInfo();
    //  alert(child_inst_id)

        return () => { };
    }, []);

    const surveyComplete = useCallback((sender) => {
 
        setIsLoading(true);
        
        let bnf_data=sender.data;
        console.clear();
console.log(bnf_data);

// bnf_data[0].beneficiary_form_details.beneficiary_details.children[0].id="XXXXXXXXXXXXXXXXX";
      let dataToSend=[{
            "beneficiary_inst_id": beneficiary_inst_id,
            "child_inst_id":child_inst_id,
            "beneficiaryregistrationproject_id":project_id,
            "component_id": component_id,
            "sync_token": null,
            "beneficiary_details":{"beneficiary_form_details":bnf_data}
    }];
         console.clear();
         console.log(dataToSend);
        setIsLoading(false);

 genericPost(ENDPOINTS.UPDATE_BENEFICIARY, dataToSend)
            .then((response) => {
                setIsLoading(false);
                if (response.status == 200) {
                    if (response.data.status == SUCCESS_RESULT) {
                        cogoToast.success(response.data.message, {
                            hideAfter: 5,
                        });
                        console.log("dataToSend",dataToSend)
                        console.log("Result",response.data)
                        
                       history.goBack();
                        // history.push({
                        //     pathname: "",
                        //     state: {
                        //         data: "",
                        //     },
                        // });
                    } else {
                        cogoToast.error(response.data.message, {
                            hideAfter: 5,
                        });
                        console.log("dataToSend",dataToSend)
                    }
                }
            })
            .catch((err) => {
                setIsLoading(false);
                console.log(err);
                console.log("dataToSend",dataToSend)
                cogoToast.error("Something went wrong, please Try again. " + err, {
                    hideAfter: 5,
                });
            });
    }, []);


    const surveyCss = {
        actionBar: {
            root: "sd-action-bar custom-actionbar-root",
        },
        navigation: {
            complete: "sd-btn--action sd-navigation__complete-btn custom-btn",
            prev: "sd-navigation__prev-btn custom-btn",
            next: "sd-navigation__next-btn custom-btn",
            start: "sd-navigation__start-btn custom-btn",
            preview: "sd-navigation__preview-btn custom-btn",
        }
    }
    surveyModel.onComplete.add(surveyComplete);

    const getBNFInfo = () => {
        setIsLoading(true);
        console.clear();
console.log({"beneficiary_inst_id":beneficiary_inst_id})
 
        genericPost(ENDPOINTS.BENEFICIARY_DETAILS, 
            {"beneficiary_inst_id":beneficiary_inst_id,"child_inst_id":child_inst_id})
        .then((res) => {
            setIsLoading(false);
            if (res.status == 200) {
                if (res.data.status == SUCCESS_RESULT) {
                    cogoToast.success(res.data.message, {});

                    let template=res.data.data.template;
                    console.clear();
                   // delete template.pages[0];
                   // let cleared_template ={"pages": template.pages.filter(tmp => tmp.name !== "scoring_criteria")};
                    // template["can_proceed"]=true;
                    // console.log(cleared_template)
                    setTemplate(template);
                     setTimeout(() => {
                        console.log("Data for BNF",res.data.data.beneficiary_details)
                    setBeneficiary_details(res.data.data.beneficiary_details);
                        
                    }, 1000);
               



                } else {
                    cogoToast.error(res.data.message, {});
                }
            }
        })
        .catch((err) => {
            setIsLoading(false);
            console.log(err);
        });
     
    };



    return (
        <div className="card">
 
            <Breadcrumb className="ms-1">
                <BreadcrumbItem>
                    <Link to="/ebms"> EBMS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem >
                    <Link to="/projects"> PROJECTS </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>
                    <Link to="/"> UPDATE BENEFICIARY DETAILS </Link>
                </BreadcrumbItem>
            </Breadcrumb>

            <div className="d-flex justify-content-center my-1">
                {isLoading && <Spinner />}
            </div>
            
            {/* {JSON.stringify(beneficiary_details)} */}
            <div className="ag-theme-alpine responsive margin20">


 
                <Survey model={surveyModel} css={surveyCss} data={formData} />
            </div>
        </div>);
 
};
export default UpdateBeneficiaryDetails;